// extracted by mini-css-extract-plugin
module.exports = {"optional--text":"optional--text__3yV1C"};